export const REPROCESSING_INVOICE_FILE_TYPE_BINARY = [
  'image/gif',
  'image/jpeg',
  'image/png',
  'application/pdf',
] as const;

export const REPROCESSING_INVOICE_FILE_TYPE = [
  ...REPROCESSING_INVOICE_FILE_TYPE_BINARY,
  'text/csv',
  'application/json',
  'application/xml',
] as const;
